import React, { useEffect } from 'react';
// import '../css/styles.scss';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  withRouter
} from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import LandingPage from './LandingPage';
import theme from './theme';
import { MuiThemeProvider } from '@material-ui/core';
import { setSession } from '../actions/login';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/custom.css';
import '../css/styles.css';

import Routes from './PrivateRoute/Routes';
import Faq from './LandingPage/Faq';
import PrivacyPolicy from './LandingPage/PrivacyPolicy';
import TermsAndConditions from './LandingPage/TermsAndConditions';
import CancellationRefundPolicy from './LandingPage/cancellationRefundPolicy';
import DeleteUser from './LandingPage/DeleteUser';
import { SOCKET_URL_ENDPOINT } from '../constants';
import io from 'socket.io-client';

const NotFoundPage = () => <div>404 page is not found!</div>;
// const socket = io(SOCKET_URL_ENDPOINT);
// console.log(socket);

// socket.on('connect_error', error => {
//   console.error('Failed to connect to socket server:', error);
// });

const App = ({ match, history }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  let session = sessionStorage.getItem('user');

  // useEffect(() => {
  //   socket.on('connect', function() {
  //     console.log('Connected to socket server');
  //   });
  //   socket.on('connect-admin', function(orderData) {
  //     console.log('🆕 New order received:', orderData);
  //   });

  //   return () => {
  //     socket.off('connect-admin');
  //   };
  // }, []);

  useEffect(() => {
    const publicRoutes = [
      '/faq',
      '/privacy-policy',
      '/terms-and-conditions',
      '/cancellation-and-refund-policy',
      '/delete-user',
      '/'
    ];

    if (session && JSON.parse(session) && JSON.parse(session).token) {
      dispatch(setSession(JSON.parse(session)));
    } else {
      if (!publicRoutes.includes(location.pathname)) {
        history.push('/');
        window.location.reload();
      }
    }
  }, [session]);

  return (
    <MuiThemeProvider theme={theme}>
      <ToastContainer />
      <Router>
        <Switch>
          <Route exact path="/" component={LandingPage} />
          {Routes.map(route => {
            return (
              <PrivateRoute
                key={route.path}
                exact
                path={route.path}
                render={props => route.component}
              />
            );
          })}
          <Route exact path="/faq" component={Faq} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route
            exact
            path="/terms-and-conditions"
            component={TermsAndConditions}
          />
          <Route
            exact
            path="/cancellation-and-refund-policy"
            component={CancellationRefundPolicy}
          />
          <Route exact path="/delete-user" component={DeleteUser} />
          <Route path="*" exact component={NotFoundPage} />
        </Switch>
      </Router>
    </MuiThemeProvider>
  );
};
export default withRouter(App);
